import { formatText } from "../pushNotificationMessage";

const messages = async ({actionType, notifyContent}) => {

    const message = {
        newEnquiry: {
            title: `חקירה חדשה`,
            message: `${formatText(notifyContent['userName'])}: ${notifyContent['messageContent']}`
        },
        declined: {
            title: `נדחה`,
            message: `${formatText(notifyContent['userName'])}ההזמנה נדחתה`
        },
        approved: {
            title: `אושר`,
            message: `${formatText(notifyContent['userName'])}ההזמנה אושרה`
        },
        newMessage: {
            title: `הודעה חדשה`,
            message: `${formatText(notifyContent['userName'])}: ${notifyContent['messageContent']}`
        },
        cancelReservation: {
            title: `ההזמנה מבוטלת`,
            message: `${formatText(notifyContent['userName'])}: ${notifyContent['messageContent']}`
        },
        newBooking: {
            title: `הזמנה חדשה`,
            message: `${formatText(notifyContent['userName'])}: ${notifyContent['messageContent']}`
        },
        preApprove: {
            title: `הזמנה חדשה`,
            message: `${formatText(notifyContent['userName'])}: בקשתך אושרה מראש`
        },
        listApproved: {
            title: `מנהל המערכת אימת את הרישום שלך`,
            message: `${formatText(notifyContent['userName'])} : מנהל האתר אימת את המודעה שלך ${notifyContent['listTitle']} . אנא פרסם את המודעה שלך כדי לקבל הזמנות.`
        },
        listDeclined: {
            title: `מנהל המערכת דחה את הרישום שלך`,
            message: `${formatText(notifyContent['userName'])} : מנהל המערכת דחה את בקשת הרישום שלך עבור ${notifyContent['listTitle']} עקב הסיבה ${notifyContent['reason']}. אנא עדכן את פרטי הרישום ושלח לאישור הרשימה.`
        },
        noHostPayout: {
            title: `חסרים פרטי תשלום`,
            message: `${formatText(notifyContent['userName'])}:עדכון! אנא עדכן את פרטי התשלום שלך כדי לקבל את תשלומי ההזמנה`
        },
        approvedDocument: {
            title: `המסמך אושר!`,
            message: `המסמך שלך אושר בהצלחה.`
        },
        rejectDocument: {
            title: `המסמך נדחה!`,
            message: `המסמך שהגשת נדחה על ידי המנהל. אנא צור קשר עם המנהל לקבלת מידע נוסף.`
        }
    }

    return message[actionType]
}
export default messages;